import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { CadastroGenerico } from '../../models/generics/cadastro-generico';
import { GenericIdbaRequestModel } from '../../models/generic-idba-request-model';
import { ConfigService } from '../config.service';

interface CadastroGenericoLookupResponse {
  data?: {
    registro?: unknown[];
  };
}

@Injectable({ providedIn: 'root' })
export class CadastroGenericoLookupService {
  private readonly http = inject(HttpClient);
  private readonly configService = inject(ConfigService);

  listByModuloAssunto(modulo: string, assunto: string): Observable<readonly CadastroGenerico[]> {
    const request = new GenericIdbaRequestModel();
    request.program = 'cad/genericos/cadgenerico.p';
    request.procedure = 'pi-listar-modulo-assunto';
    request.parameters = { modulo, assunto };

    return this.http
      .post<CadastroGenericoLookupResponse>(
        this.configService.getApiUrl('integrateUrl'),
        request,
        { observe: 'response' },
      )
      .pipe(
        map((response) =>
          (response.body?.data?.registro ?? []).map((registro) =>
            new CadastroGenerico(registro as Partial<CadastroGenerico>),
          ),
        ),
      );
  }
}
